import { fill, scale } from '@cloudinary/url-gen/actions/resize'
import { Link } from '@tanstack/react-router'
import React from 'react'

import { Box, BoxProps, Flex } from '@masterplandev/ui'

import { cloudinary } from '@/cloudinary/cloudinary'
import { CloudinaryImage } from '@/cloudinary/CloudinaryImage'
import CompanyLogo from '@/company/components/CompanyLogo/CompanyLogo'

function BoxCenter(props: BoxProps) {
  return (
    <Box
      flex="1"
      display="flex"
      justifyContent="center"
      sx={{
        ':first-of-type > *': { mr: 'auto' },
        ':last-of-type > *': { ml: 'auto' },
      }}
      {...props}
    />
  )
}

export function PollFormHeader({ children }: { children: React.ReactNode }) {
  return (
    <Flex justify="space-between" h="6">
      <BoxCenter display={{ base: 'none', lg: 'block' }}>
        <Link to="/home">
          <CloudinaryImage
            height="24px"
            image={cloudinary
              .image('system/core-skills-assessment/Logo.svg')
              .resize(fill().height(24))}
          />
        </Link>
      </BoxCenter>
      <BoxCenter>{children}</BoxCenter>
      <BoxCenter display={{ base: 'none', lg: 'block' }}>
        <CompanyLogo height="24px" resize={scale().height(24)} />
      </BoxCenter>
    </Flex>
  )
}
